/**
 * Developed By Aritra Basak, EY
 * (Latest )
 */
import React, { useEffect, useRef } from "react";
import { Box, colors } from "@material-ui/core";
import { Stepper } from "@material-ui/core";
import { Step } from "@material-ui/core";
import { StepLabel } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Modal } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Checkbox } from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import VerifiedUserTwoToneIcon from "@material-ui/icons/VerifiedUserTwoTone";
import CancelTwoToneIcon from "@material-ui/icons/CancelTwoTone";
import { CreateTwoTone, Visibility, VisibilityOff } from "@material-ui/icons";
import { InputAdornment } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import { Paper } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Table } from "@material-ui/core";
import { TableBody } from "@material-ui/core";
import { TableCell } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { RadioGroup } from "@mui/material";
import { Radio } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { FormControl } from "@material-ui/core";
import { FormLabel } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import { Link } from "react-router-dom";
import { asyncPost } from "../../../common/utils";
import { URI } from "../../../constants";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import {
  RESEND_OTP_TIMEOUT,
  RESEND_OTP_CHANCE,
} from "../../../constants/dataconstants";
import "../../../assets/styles/V3.css";
import AadhaarInput from "../AadhaarInput";
import { green } from "@material-ui/core/colors";
import { red } from "@mui/material/colors";

const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5"];

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "white !important",
  },
  stepper: {
    display: "flex",
    "& .MuiStepIcon-active": { color: global.secondaryColour },
    "& .MuiStepIcon-completed": { color: global.secondaryColour },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ccc" },
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(10),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  form: {
    width: "100%",
    padding: theme.spacing(5),
  },
  button: {
    margin: theme.spacing(1),
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
  },
}));

function VerifyAbhaV3_old() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [authValue, setAuthValue] = React.useState("");
  const [authMode, setAuthMode] = React.useState("");
  const [txnId, setTxnId] = React.useState("");
  const [authCode, setAuthCode] = React.useState("");
  const [xToken, setXToken] = React.useState("");
  const [patientName, setPatientName] = React.useState("");
  const [healthIdRes, setHealthIdRes] = React.useState("");
  const [healthIdNoRes, setHealthIdNoRes] = React.useState("");
  const [mobileRes, setMobileRes] = React.useState();
  const [dobRes, setDobRes] = React.useState();
  const [dob, setDob] = React.useState();
  const [genderRes, setGenderRes] = React.useState();
  const [addressRes, setAddressRes] = React.useState("");
  const [districtCodeRes, setDistrictCodeRes] = React.useState();
  const [stateCodeRes, setStateCodeRes] = React.useState();
  const [pinCodeRes, setPinCodeRes] = React.useState("");
  const [kycPhotoRes, setKycPhotoRes] = React.useState();
  const [showLoader, setShowLoader] = React.useState(false);
  const [profileImageRes, setProfileImageRes] = React.useState();
  const [modalData, setModalData] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [modalFor, setModalFor] = React.useState("default");
  const [buttonText, setButtonText] = React.useState("RESEND OTP");
  const [resendOtpChance, setResendOtpChance] = React.useState(0);
  const [isNewProfile, setIsNewProfile] = React.useState("");
  const [yearOfBirth, setYearOfBirth] = React.useState("");
  const [stateName, setStateName] = React.useState("");
  const [districtName, setDistrictName] = React.useState("");
  const [selectedMethodValue, setSelectedMethodValue] =
    React.useState("mobile");
  const [abhaProfileList, setAbhaProfileList] = React.useState([]);
  const [intervalId, setIntervalId] = React.useState(null);
  const [showAadhaar, setShowAadhaar] = React.useState(false);
  const [isAbhaGenerated, setIsAbhaGenerated] = React.useState(true);
  const [updatesComplete, setUpdatesComplete] = React.useState(false);
  const [preferredAbhaAddress, setPreferredAbhaAddress] = React.useState(null);
  const [phrAddress, setPhrAddress] = React.useState([]);

  useEffect(() => {
    if (updatesComplete) {
      backToHome();
      setUpdatesComplete(false); // Reset the updatesComplete state
    }
  }, [updatesComplete]);

  // useEffect(() => {
  //   global.mobileNumber === ""
  //     ? setAuthValue("")
  //     : setAuthValue(global.mobileNumber);
  // }, []);

  useEffect(() => {
    console.log(selectedMethodValue);
    selectedMethodValue === "mobile"
      ? setAuthValue(global.mobileNumber)
      : setAuthValue("");
  }, [selectedMethodValue]);

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleAuthValue = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAuthValue(value);
    } else {
      setAuthValue((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const handleAuthCode = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAuthCode(value);
    } else {
      setAuthCode((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };
  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    if (activeStep === 1) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      setAuthCode("");
      clearInterval(intervalId);
    }
    if (activeStep === 2 || activeStep === 3) {
      resetHooks();
      setActiveStep(0);
    }
    clearInterval(intervalId);
  };

  //if the handleModalOpen() is called without a parameter then by default "default" will be set in modalForValue else if value is passed then that value will be set.
  const handleModalOpen = (modalForValue = "default") => {
    modalForValue === "default"
      ? setModalFor("default")
      : global.isGovtEntity === 1
      ? setModalFor("2ndStage")
      : setModalFor("default");
    setModalState(true);
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  const resendOtpButtontext = () => {
    let count = parseInt(resendOtpChance);
    let i = RESEND_OTP_TIMEOUT;
    if (i > 0 && count < RESEND_OTP_CHANCE) {
      const id = setInterval(() => {
        setButtonText("RESEND OTP AFTER: " + i);
        i = i - 1;
        if (i < 0) {
          count++;
          i = RESEND_OTP_TIMEOUT;
          setResendOtpChance(count.toString());
          count > RESEND_OTP_CHANCE
            ? setButtonText("CANNOT USE RESEND OTP")
            : setButtonText("RESEND OTP");
          clearInterval(id); // Clear interval using local variable
        }
      }, 1000);
      setIntervalId(id); // Save intervalId in state
    }
    if (count >= RESEND_OTP_CHANCE) {
      setButtonText("CANNOT USE RESEND OTP");
    }
  };

  const generateScreen = () => {
    if (activeStep == 0) {
      return populateScreenFlowOne();
    } else if (activeStep == 1) {
      return populateScreenFlowTwo();
    } else if (activeStep == 2) {
      return populateScreenFlowThree();
    } else if (activeStep == 3) {
      return populateScreenFlowFour();
    } else if (activeStep == 4) {
      return populateScreenFlowFive();
    }
  };
  //Function to get OTP for authentication with respect to the mode selected.
  const onGetOtp = async (value = null) => {
    if (selectedMethodValue === "aadhaar" && value !== null) {
      console.log("Aadhaar Value", value);
      setAuthValue(value);
    }
    clearInterval(intervalId); //Clearing the resendOTP button timer interval at the start, so that if someone exit the process before confirming the OTP and restart the process, correct OTP timer will be displayed.
    if (authValue.trim() === "" && value === null) {
      selectedMethodValue === "mobile"
        ? setModalData("Kindly enter your Mobile Number.")
        : selectedMethodValue === "aadhaar"
        ? setModalData("Kindly enter your Aadhaar Number")
        : setModalData("Kindly enter your ABHA Number or ABHA Address");
      handleModalOpen();
      return false;
    }

    if (selectedMethodValue === "mobile" && authValue.trim().length !== 10) {
      setModalData("Kindly enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (
      selectedMethodValue === "mobile" &&
      authValue.trim().match(/^[0-9]+$/) === null
    ) {
      setModalData("Kindly enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (selectedMethodValue === "aadhaar" && value.trim().length !== 12) {
      setModalData("Kindly enter a valid Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    if (selectedMethodValue === "aadhaar" && value.match(/^[0-9]+$/) === null) {
      setModalData("Kindly enter a valid Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo =
      selectedMethodValue === "mobile"
        ? {
            //For Mobile Verification
            loginId: authValue,
            loginHint: "mobile",
          }
        : selectedMethodValue === "aadhaar"
        ? {
            //For Aadhaar Verification
            loginId: value,
            loginHint: "aadhaar",
          }
        : selectedMethodValue === "number"
        ? {
            //For ABHA Number Verification
            loginId: authValue,
            loginHint: "abha-number",
            authMethod: authMode,
          }
        : {
            //For ABHA Address Verification
            healthId: authValue,
            authMode: authMode,
          };
    // debugger;
    const res = await asyncPost(
      selectedMethodValue === "address" ? URI.authInit : URI.v3authInit,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success" || res.status == 2000) {
      //debugger;
      selectedMethodValue === "address"
        ? setTxnId(res.data.txnId)
        : setTxnId(res.resObject.txnId);
      setIsAbhaGenerated(true);
      selectedMethodValue === "mobile"
        ? setModalData(
            "Successfully sent OTP to the Communication Mobile number ending with ******" +
              String(authValue).substring(6, 11)
          )
        : selectedMethodValue === "address" && authMode === "AADHAAR_OTP"
        ? setModalData(
            "OTP has been sent to the ABHA registered Aadhaar Linked Mobile Number."
          )
        : selectedMethodValue === "address" && authMode === "MOBILE_OTP"
        ? setModalData(
            "OTP has been sent to the ABHA registered Mobile Number."
          )
        : setModalData(res.resObject.message);
      handleModalOpen();
      handleNext();
      resendOtpButtontext();
      setShowLoader(false);
    } else {
      //debugger;
      setShowLoader(false);
      setIsAbhaGenerated(true);
      if (res && res.resObject) {
        if (
          res.resObject.hasOwnProperty("error") &&
          (String(JSON.stringify(res.resObject.error.code)).includes(
            "ABDM-1115"
          ) ||
            String(JSON.stringify(res.resObject.error.message)).includes(
              "The Communication Mobile Number you have entered does not match with any of the records. Please enter a different Communication Mobile Number."
            ))
        ) {
          setIsAbhaGenerated(false);
          setModalData(res.resObject.error.message);
          handleModalOpen("default");
          return false;
        } else if (
          res.resObject.hasOwnProperty("loginId") &&
          res.resObject.loginId === "Invalid LoginId"
        ) {
          selectedMethodValue === "mobile"
            ? setModalData(
                res.resObject.loginId + ". Kindly enter a valid Mobile Number."
              )
            : setModalData(
                res.resObject.loginId + ". Kindly enter a valid Aadhaar Number."
              );
          handleModalOpen("default");
          return false;
        } else if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("error")
        ) {
          setModalData(res.resObject.error.message);
          handleModalOpen("default");
          return false;
        }
      } else {
        if (res && res.ndhmErrorMsg) {
          if (res.ndhmErrorMsg.details && res.ndhmErrorMsg.details[0]) {
            setModalData(res.ndhmErrorMsg.details[0].message);
            handleModalOpen("default");
            return false;
          } else {
            setModalData(res.ndhmErrorMsg.message);
            handleModalOpen("default");
            return false;
          }
        } else {
          console.error("Response object or resObject is undefined:", res);
          setModalData("An unexpected error occurred. Please try again.");
          handleModalOpen("default");
          return false;
        }
      }
    }
  };

  //Function to resend OTP for authentication with the respective selected mode.
  const resendConfirmOtp = async () => {
    setShowLoader(true);
    var count = parseInt(resendOtpChance);
    count++;
    setResendOtpChance(count);
    const __oo =
      selectedMethodValue === "mobile"
        ? {
            loginId: authValue,
            loginHint: "mobile",
          }
        : selectedMethodValue === "aadhaar"
        ? {
            loginId: authValue,
            loginHint: "aadhaar",
          }
        : selectedMethodValue === "number"
        ? {
            //For ABHA Number Verification
            loginId: authValue,
            loginHint: "abha-number",
            authMethod: authMode,
          }
        : {
            //For ABHA Address Verification
            healthId: authValue,
            authMode: authMode,
          };
    // debugger;
    const res = await asyncPost(
      selectedMethodValue === "address" ? URI.authInit : URI.v3authInit,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success" || res.status == 2000) {
      //debugger;
      selectedMethodValue === "address"
        ? setTxnId(res.data.txnId)
        : setTxnId(res.resObject.txnId);
      resendOtpButtontext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        parseInt(res.statusCode) === 0 &&
        res.resObject.hasOwnProperty("message")
      ) {
        setModalData(res.resObject.message);
        handleModalOpen();
        return false;
      } else if (String(res.responseMessage).includes("Failure")) {
        setModalData(
          "Message from ABDM : Could not resend OTP. Please try again after sometime."
        );
        handleModalOpen();
        return false;
      }
    }
  };
  const handleShowAadhaar = () => {
    setShowAadhaar(!showAadhaar);
  };

  // To verify the generated OTP in the previous step and proceed to next page
  const onConfirm = async () => {
    if (authCode.trim() == "") {
      setModalData("Kindly Enter your OTP first.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo =
      selectedMethodValue === "mobile"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "mobile",
          }
        : selectedMethodValue === "aadhaar"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "aadhaar",
          }
        : selectedMethodValue === "number" && authMode === "AADHAAR_OTP"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "aadhaar",
          }
        : selectedMethodValue === "number" && authMode === "MOBILE_OTP"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "mobile",
          }
        : {
            txnId: txnId, //transaction ID
            otp: authCode,
          };
    // debugger;
    const res = await asyncPost(
      selectedMethodValue === "address" && authMode === "MOBILE_OTP"
        ? URI.authConfirmWithMobileOtp
        : selectedMethodValue === "address" && authMode === "AADHAAR_OTP"
        ? URI.authConfirmWithAadhaarOtp
        : URI.v3authConfirm,
      __oo,
      true,
      true,
      global.token
    );
    console.log("authConfirm : " + JSON.stringify(res.resObject));
    if (res.status === "Success") {
      //debugger;
      if (
        res.resObject.hasOwnProperty("authResult") &&
        res.resObject.authResult === "failed"
      ) {
        setIsAbhaGenerated(true);
        setModalData(res.resObject.message);
        handleModalOpen();
        setShowLoader(false);
        return false;
      } else {
        setXToken(res.resObject.token);
        setAbhaProfileList(res.resObject.accounts);
        console.log(res.resObject.accounts);
        setModalData("Your ABHA profile has been verified successfully.");
        handleModalOpen();
        clearInterval(intervalId);
        handleNext();
        setShowLoader(false);
      }
    } else if (res.status == 2000 && selectedMethodValue === "address") {
      //ABHA Address Verification.
      setXToken(res.data.token);
      const __oo1 = {
        token: res.data.token,
      };
      // debugger;
      const res1 = await asyncPost(
        URI.getProfile,
        __oo1,
        true,
        true,
        global.token
      );
      if (res1 && res1.status == 2000) {
        //debugger;
        console.log("data " + res1.data);
        setHealthIdRes(res1.data.healthId);
        setHealthIdNoRes(res1.data.healthIdNumber);
        setProfileImageRes(res1.data.profilePhoto);
        const day =
          res1.data.hasOwnProperty("dayOfBirth") &&
          res1.data.dayOfBirth !== null
            ? res1.data.dayOfBirth.trim().length === 1
              ? "0" + res1.data.dayOfBirth
              : res1.data.dayOfBirth
            : "01";

        const month =
          res1.data.hasOwnProperty("monthOfBirth") &&
          res1.data.monthOfBirth !== null
            ? res1.data.monthOfBirth.trim().length === 1
              ? "0" + res1.data.monthOfBirth
              : res1.data.monthOfBirth
            : "01";
        setDob(day + "/" + month + "/" + res1.data.yearOfBirth);
        res1.data.hasOwnProperty("monthOfBirth") &&
        res1.data.monthOfBirth !== null &&
        res1.data.hasOwnProperty("dayOfBirth") &&
        res1.data.dayOfBirth !== null
          ? setDobRes(day + "/" + month + "/" + res1.data.yearOfBirth)
          : setDobRes(res1.data.yearOfBirth);
        setPatientName(res1.data.name);
        setGenderRes(res1.data.gender);
        setKycPhotoRes(res1.data.profilePhoto);
        setMobileRes(res1.data.mobile);
        setAddressRes(res1.data.address);
        setDistrictCodeRes(res1.data.districtCode);
        setStateCodeRes(res1.data.stateCode);
        setPinCodeRes(res1.data.pincode);
        setYearOfBirth(res1.data.yearOfBirth);
        setStateName(res1.data.stateName);
        setDistrictName(res1.data.districtName);
        setIsNewProfile(false);
        setPreferredAbhaAddress(res1.data.healthId);
        setPhrAddress(
          res1.data.hasOwnProperty("phrAddress") &&
            res1.data.phrAddress !== null &&
            res1.data.phrAddress.length > 1
            ? res1.data.phrAddress
            : null
        );
        setModalData("Your ABHA profile has been verified successfully.");
        handleModalOpen();
        setActiveStep(3);
        setShowLoader(false);
        clearInterval(intervalId);
      } else {
        setShowLoader(false);
        setModalData(
          "Message from ABDM : Unable to fetch profile.\n" +
            res1.ndhmErrorMsg.message +
            "\n" +
            res1.ndhmErrorMsg.details[0].message
        );
        handleModalOpen();
        return false;
      }
    } else {
      setShowLoader(false);
      if (
        String(
          res.resObject.hasOwnProperty("error") &&
            JSON.stringify(res.resObject.error.code)
        ).includes("ABDM-1114")
      ) {
        setIsAbhaGenerated(false);
        setModalData(res.resObject.error.message);
        handleModalOpen();
        return false;
      }
      if (
        parseInt(res.statusCode) === 0 &&
        res.resObject.error.hasOwnProperty("message")
      ) {
        setModalData(res.resObject.error.message);
        handleModalOpen();
        return false;
      } else if (
        parseInt(res.statusCode) === 0 &&
        res.resObject.hasOwnProperty("message")
      ) {
        setModalData(res.resObject.message);
        handleModalOpen();
        return false;
      } else if (String(res.responseMessage).includes("Failure")) {
        setModalData(
          "Message from ABDM : Could not validate OTP. Please try again after sometime."
        );
        handleModalOpen();
        return false;
      } else if (
        selectedMethodValue === "address" &&
        res.hasOwnProperty("ndhmErrorMsg")
      ) {
        setModalData(
          "Message from ABDM : Unable to fetch profile.\n" +
            res.ndhmErrorMsg.message +
            "\n" +
            res.ndhmErrorMsg.details[0].message
        );
        handleModalOpen();
        return false;
      }
    }
  };

  //To get the X-token and the T-token for fetching the Profile after validating the OTP
  const getProfile = async (abhaNumber, requestFor = null) => {
    setShowLoader(true);
    if (selectedMethodValue === "mobile") {
      //Verification Method is Mobile Number
      const __oo = {
        ttoken: xToken,
        abhaNumber: abhaNumber,
        txnId: txnId,
      };
      const res = await asyncPost(
        URI.v3getVerifiedProfileApi1,
        __oo,
        true,
        true,
        global.token
      );
      if (res.status === "Success") {
        setXToken(res.resObject.token);
        const __oo1 = {
          token: res.resObject.token,
        };
        const res2 = await asyncPost(
          URI.v3getVerifiedProfileApi2,
          __oo1,
          true,
          true,
          global.token
        );
        console.log(
          "v3getVerifiedProfileApi_Response : " + JSON.stringify(res2.resObject)
        );
        if (res2.status === "Success") {
          setHealthIdRes(res2.resObject.preferredAbhaAddress);
          setPreferredAbhaAddress(res2.resObject.preferredAbhaAddress);
          setPhrAddress(
            res2.resObject.hasOwnProperty("phrAddress") &&
              res2.resObject.phrAddress !== null &&
              res2.resObject.phrAddress.length > 1
              ? res2.resObject.phrAddress
              : null
          );
          setHealthIdNoRes(res2.resObject.ABHANumber);
          setProfileImageRes(res2.resObject.profilePhoto);
          const day =
            res2.resObject.hasOwnProperty("dayOfBirth") &&
            res2.resObject.dayOfBirth !== null
              ? res2.resObject.dayOfBirth.trim().length === 1
                ? "0" + res2.resObject.dayOfBirth
                : res2.resObject.dayOfBirth
              : "01";

          const month =
            res2.resObject.hasOwnProperty("monthOfBirth") &&
            res2.resObject.monthOfBirth !== null
              ? res2.resObject.monthOfBirth.trim().length === 1
                ? "0" + res2.resObject.monthOfBirth
                : res2.resObject.monthOfBirth
              : "01";
          setDob(day + "/" + month + "/" + res2.resObject.yearOfBirth);
          res2.resObject.hasOwnProperty("monthOfBirth") &&
          res2.resObject.monthOfBirth !== null &&
          res2.resObject.hasOwnProperty("dayOfBirth") &&
          res2.resObject.dayOfBirth !== null
            ? setDobRes(day + "/" + month + "/" + res2.resObject.yearOfBirth)
            : setDobRes(res2.resObject.yearOfBirth);
          setPatientName(res2.resObject.name);
          setGenderRes(res2.resObject.gender);
          setKycPhotoRes(res2.resObject.profilePhoto);
          setMobileRes(res2.resObject.mobile);
          setAddressRes(res2.resObject.address);
          setDistrictCodeRes(res2.resObject.districtCode);
          setStateCodeRes(res2.resObject.stateCode);
          setPinCodeRes(res2.resObject.pincode);
          setYearOfBirth(res2.resObject.yearOfBirth);
          setStateName(res2.resObject.stateName);
          setDistrictName(res2.resObject.districtName);
          setIsNewProfile(false);
          setShowLoader(false);
          if (requestFor === null) {
            setUpdatesComplete(true); // Indicate that updates are complete
          } else {
            handleNext();
          }
        } else {
          setShowLoader(false);
          if (
            parseInt(res2.statusCode) === 0 &&
            res2.resObject.hasOwnProperty("error")
          ) {
            setModalData(res2.resObject.error.message);
            handleModalOpen();
            return false;
          } else if (
            parseInt(res2.statusCode) === 0 &&
            res2.resObject.hasOwnProperty("message")
          ) {
            setModalData(res2.resObject.message);
            handleModalOpen();
            return false;
          } else if (String(res2.responseMessage).includes("Failure")) {
            setModalData(
              "Message from ABDM : Could not get verified profile. Please try again after sometime."
            );
            handleModalOpen();
            return false;
          }
        }
      } else {
        setShowLoader(false);
        if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.message);
          handleModalOpen();
          return false;
        } else if (String(res.responseMessage).includes("Failure")) {
          setModalData(
            "Message from ABDM : Could not get X-Token. Please try again after sometime."
          );
          handleModalOpen();
          return false;
        }
      }
    } else {
      const __oo1 = {
        token: xToken,
      };
      const res2 = await asyncPost(
        URI.v3getVerifiedProfileApi2,
        __oo1,
        true,
        true,
        global.token
      );
      console.log(
        "v3getVerifiedProfileApi_Response : " + JSON.stringify(res2.resObject)
      );
      if (res2.status === "Success") {
        setHealthIdRes(res2.resObject.preferredAbhaAddress);
        setPreferredAbhaAddress(res2.resObject.preferredAbhaAddress);
        setPhrAddress(
          res2.resObject.hasOwnProperty("phrAddress") &&
            res2.resObject.phrAddress !== null &&
            res2.resObject.phrAddress.length > 1
            ? res2.resObject.phrAddress
            : null
        );
        setHealthIdNoRes(res2.resObject.ABHANumber);
        setProfileImageRes(res2.resObject.profilePhoto);
        const day =
          res2.resObject.hasOwnProperty("dayOfBirth") &&
          res2.resObject.dayOfBirth !== null
            ? res2.resObject.dayOfBirth.trim().length === 1
              ? "0" + res2.resObject.dayOfBirth
              : res2.resObject.dayOfBirth
            : "01";

        const month =
          res2.resObject.hasOwnProperty("monthOfBirth") &&
          res2.resObject.monthOfBirth !== null
            ? res2.resObject.monthOfBirth.trim().length === 1
              ? "0" + res2.resObject.monthOfBirth
              : res2.resObject.monthOfBirth
            : "01";
        setDob(day + "/" + month + "/" + res2.resObject.yearOfBirth);
        res2.resObject.hasOwnProperty("monthOfBirth") &&
        res2.resObject.monthOfBirth !== null &&
        res2.resObject.hasOwnProperty("dayOfBirth") &&
        res2.resObject.dayOfBirth !== null
          ? setDobRes(day + "/" + month + "/" + res2.resObject.yearOfBirth)
          : setDobRes(res2.resObject.yearOfBirth);
        setPatientName(res2.resObject.name);
        setGenderRes(res2.resObject.gender);
        setKycPhotoRes(res2.resObject.profilePhoto);
        setMobileRes(res2.resObject.mobile);
        setAddressRes(res2.resObject.address);
        setDistrictCodeRes(res2.resObject.districtCode);
        setStateCodeRes(res2.resObject.stateCode);
        setPinCodeRes(res2.resObject.pincode);
        setYearOfBirth(res2.resObject.yearOfBirth);
        setStateName(res2.resObject.stateName);
        setDistrictName(res2.resObject.districtName);
        setIsNewProfile(false);
        setShowLoader(false);
        if (requestFor === null) {
          setUpdatesComplete(true); // Indicate that updates are complete
        } else {
          handleNext();
        }
      } else {
        setShowLoader(false);
        if (
          parseInt(res2.statusCode) === 0 &&
          res2.resObject.hasOwnProperty("message")
        ) {
          setModalData(res2.resObject.message);
          handleModalOpen();
          return false;
        } else if (String(res2.responseMessage).includes("Failure")) {
          setModalData(
            "Message from ABDM : Could not get verified profile. Please try again after sometime."
          );
          handleModalOpen();
          return false;
        }
      }
    }
  };

  //To get the Health Card of the verified profile
  const getHealthCard = async () => {
    setShowLoader(true);
    const __oo =
      selectedMethodValue === "address"
        ? {
            txnId: txnId,
            token: xToken,
          }
        : {
            token: xToken,
          };
    // debugger;
    const res = await asyncPost(
      selectedMethodValue === "address" ? URI.getPngCard : URI.v3getHealthCard,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      //debugger;
      setProfileImageRes(res.resObject);
      handleNext();
      setShowLoader(false);
    } else if (res.status === 2000) {
      setProfileImageRes(res.data);
      handleNext();
      setShowLoader(false);
    } else {
      debugger;
      setShowLoader(false);
      if (res.resObject.error && res.resObject.hasOwnProperty("message")) {
        setModalData(res.resObject.error.message);
        handleModalOpen();
        return false;
      } else if (String(res.responseMessage).includes("Failure")) {
        setModalData(
          "Could not get ABHA card. Please try again after sometime."
        );
        handleModalOpen();
        return false;
      } else if (
        selectedMethodValue === "address" &&
        res.hasOwnProperty("ndhmErrorMsg")
      ) {
        setModalData(
          "Unable to fetch ABHA card.\n" +
            res.ndhmErrorMsg.message +
            "\n" +
            res.ndhmErrorMsg.details[0].message
        );
        handleModalOpen();
        return false;
      } else {
        setModalData(res.responseMessage);
        handleModalOpen();
        return false;
      }
    }
  };

  const handleRadioChange = (event) => {
    setSelectedMethodValue(event.target.value);
    if (authValue.trim() !== "") setAuthValue("");
  };

  const postMessageToParent = async () => {
    const __oo = {
      name: patientName,
      healthId: preferredAbhaAddress,
      healthIdNumber: healthIdNoRes,
      gender: genderRes,
      mobile: mobileRes,
      dob: dob,
      isNew: isNewProfile,
      yearOfBirth: yearOfBirth,
      pngCard: profileImageRes,
      kycPhoto: kycPhotoRes,
      address: addressRes,
      districtCode: districtCodeRes,
      stateCode: stateCodeRes,
      pinCode: pinCodeRes,
      stateName: stateName,
      districtName: districtName,
      aadhaarNumber: "",
    };
    console.log(__oo);
    //Posting a Json message to the parent application.
    window.parent.postMessage(JSON.stringify(__oo), "*");
  };

  const backToHome = async () => {
    postMessageToParent();
    setActiveStep(0);
    resetHooks();
  };
  //This Event is trigerred from the parent web UI.
  window.addEventListener("message", function (event) {
    if (event.data === "closeWindow") {
      postMessageToParent();
    }
  });

  const resetHooks = () => {
    if (global.mobileNumber === "" || global.mobileNumber === null) {
      setAuthValue("");
    }
    setSelectedMethodValue("mobile");
    setAuthCode("");
    setXToken("");
    setResendOtpChance(0);
    clearInterval(intervalId);
    setModalFor("1stStage");
    setIsAbhaGenerated(true);
    setPhrAddress([]);
    setPreferredAbhaAddress(null);
  };

  //For downloading the card
  const downloadPng = async () => {
    // window.location.href = 'data:application/octet-stream;base64,' + profileImageRes;
    var a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + profileImageRes; //Image Base64 Goes here
    a.download = "VerifiedHealthCard.png"; //File name Here
    a.click(); //Downloaded file
  };
  //Full Authentication form for generating OTP
  const populateScreenFlowOne = () => {
    return (
      <div className="my-2">
        <div className="text-center">
          <FormControl component="fieldset">
            <FormLabel
              component="legend"
              className="fw-bold"
              style={{ color: global.secondaryColour }}
            >
              Select a Method to Verify ABHA
            </FormLabel>
            <RadioGroup
              aria-label="method"
              name="controlled-radio-buttons-group"
              row
              className="text-center"
            >
              <FormControlLabel
                value="mobile"
                control={
                  <Radio
                    checked={selectedMethodValue === "mobile"}
                    onChange={handleRadioChange}
                  />
                }
                label="Mobile Number"
              />
              <FormControlLabel
                value="aadhaar"
                control={
                  <Radio
                    checked={selectedMethodValue === "aadhaar"}
                    onChange={handleRadioChange}
                  />
                }
                label="Aadhaar Number"
              />
              <FormControlLabel
                value="address"
                control={
                  <Radio
                    checked={selectedMethodValue === "address"}
                    onChange={handleRadioChange}
                  />
                }
                label="ABHA Address"
              />
              <FormControlLabel
                value="number"
                control={
                  <Radio
                    checked={selectedMethodValue === "number"}
                    onChange={handleRadioChange}
                  />
                }
                label="ABHA Number"
              />
            </RadioGroup>
          </FormControl>
        </div>
        <form className={classes.form} noValidate>
          <Grid
            container
            direction={"row"}
            spacing={5}
            alignItems="center"
            justifyContent="center"
          >
            {selectedMethodValue === "mobile" ? (
              <React.Fragment>
                <Grid item>
                  <TextField
                    variant="standard"
                    margin="normal"
                    inputProps={{ maxLength: 10 }}
                    label={"Communication Mobile Number"}
                    required
                    id="healthId"
                    value={authValue}
                    name="healthId"
                    style={{ marginTop: -1, width: "300px" }}
                    onChange={(e) => handleAuthValue(e.target.value)}
                  />
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: global.secondaryColour,
                      color: "#fff",
                      paddingBottom: 10,
                      marginTop: 7,
                    }}
                    className={classes.submit}
                    onClick={() => onGetOtp()}
                  >
                    Get OTP
                  </Button>
                </Grid>
              </React.Fragment>
            ) : selectedMethodValue === "aadhaar" ? (
              <Grid item>
                <AadhaarInput handleOtp={onGetOtp} />
              </Grid>
            ) : selectedMethodValue === "number" ? (
              <React.Fragment>
                <Grid item>
                  <TextField
                    variant="standard"
                    margin="normal"
                    inputProps={{ maxLength: 14 }}
                    label={"ABHA Number"}
                    required
                    id="abhaNumber"
                    value={authValue}
                    name="abhaNumber"
                    style={{ marginTop: -1, width: "300px" }}
                    onChange={(e) => handleAuthValue(e.target.value)}
                  />
                </Grid>
                <Grid item style={{ marginBottom: 10 }}>
                  <InputLabel id="loginAsLabel">Authentication Mode</InputLabel>
                  <Select
                    fullWidth
                    labelId="authMode"
                    id="authMode"
                    className={classes.selectEmpty}
                    onChange={(e) => {
                      setAuthMode(e.target.value);
                    }}
                  >
                    <MenuItem value="">
                      <strong>None</strong>
                    </MenuItem>
                    <MenuItem value={"AADHAAR_OTP"}>
                      <strong>AADHAAR OTP</strong>
                    </MenuItem>
                    <MenuItem value={"MOBILE_OTP"}>
                      <strong>MOBILE OTP</strong>
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: global.secondaryColour,
                      color: "#fff",
                      paddingBottom: 10,
                      marginTop: 7,
                    }}
                    className={classes.submit}
                    onClick={() => onGetOtp()}
                  >
                    Get OTP
                  </Button>
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Grid item>
                  <TextField
                    variant="standard"
                    margin="normal"
                    inputProps={{ maxLength: 22 }}
                    label={"ABHA Address"}
                    required
                    id="abhaAddress"
                    value={authValue}
                    name="abhaAddress"
                    style={{ marginTop: -1, width: "300px" }}
                    onChange={(e) => setAuthValue(e.target.value)}
                  />
                </Grid>
                <Grid item style={{ marginBottom: 10 }}>
                  <InputLabel id="loginAsLabel">Authentication Mode</InputLabel>
                  <Select
                    fullWidth
                    labelId="authMode"
                    id="authMode"
                    className={classes.selectEmpty}
                    onChange={(e) => {
                      setAuthMode(e.target.value);
                    }}
                  >
                    <MenuItem value="">
                      <strong>None</strong>
                    </MenuItem>
                    <MenuItem value={"AADHAAR_OTP"}>
                      <strong>AADHAAR OTP</strong>
                    </MenuItem>
                    <MenuItem value={"MOBILE_OTP"}>
                      <strong>MOBILE OTP</strong>
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: global.secondaryColour,
                      color: "#fff",
                      paddingBottom: 10,
                      marginTop: 7,
                    }}
                    className={classes.submit}
                    onClick={() => onGetOtp()}
                  >
                    Get OTP
                  </Button>
                </Grid>
              </React.Fragment>
            )}
          </Grid>
        </form>
      </div>
    );
  };

  const populateScreenFlowTwo = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"row"}
          spacing={1}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <item>
              <TextField
                variant="standard"
                label={
                  selectedMethodValue === "mobile"
                    ? " Communication Mobile OTP"
                    : selectedMethodValue === "number" ||
                      selectedMethodValue === "address"
                    ? "Enter OTP"
                    : "Aadhaar OTP"
                }
                required
                id="authCode"
                value={authCode}
                inputProps={{ maxLength: 6 }}
                type="text"
                autoComplete="off"
                onChange={(e) => handleAuthCode(e.target.value)}
                InputLabelProps={
                  selectedMethodValue === "mobile"
                    ? {
                        style: { marginTop: -22 }, // Adjust the negative margin value as needed
                      }
                    : { style: { marginTop: 0 } }
                }
              />
            </item>
          </Grid>
          <Grid item>
            <item>
              <Button
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                  paddingBottom: 10,
                }}
                onClick={() => onConfirm()}
              >
                Verify & Proceed
              </Button>
            </item>
          </Grid>
          <Grid item>
            <item>
              <Button
                variant="contained"
                style={{
                  backgroundColor:
                    buttonText === "RESEND OTP"
                      ? global.secondaryColour
                      : "#ccc",
                  color: "#fff",
                  paddingBottom: 10,
                }}
                onClick={() => resendConfirmOtp()}
                disabled={buttonText === "RESEND OTP" ? false : true}
              >
                {buttonText}
              </Button>
            </item>
          </Grid>

          <Grid item>
            <item
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {resendOtpChance === 3 ? (
                ""
              ) : (
                <span>
                  You can resend OTP{" "}
                  <span style={{ color: "#D20062" }}>
                    {resendOtpChance > 0
                      ? parseInt(RESEND_OTP_CHANCE) -
                        parseInt(resendOtpChance) +
                        1
                      : 2}
                  </span>{" "}
                  more times
                </span>
              )}
            </item>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowThree = () => {
    return (
      <form
        className={classes.form}
        noValidate
        style={{ overflowY: "auto", height: "420px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h5
            style={{
              color: global.secondaryColour,
              marginBottom: "30px",
              fontWeight: "bold",
            }}
          >
            ABHA Profiles
          </h5>
        </div>
        <Grid
          container
          direction="column"
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          {abhaProfileList.map((profile, index) => (
            <Grid item key={index}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button onClick={() => getProfile(profile.ABHANumber)}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                      justifyContent: "start",
                    }}
                  >
                    <img
                      src={"data:image/png;base64, " + profile.profilePhoto}
                      alt="ABHA Patient"
                      style={{
                        height: "140px",
                        marginRight: "100px",
                      }}
                    />
                  </div>
                  <div style={{ width: "400px" }} className="text-start">
                    <p>
                      Name:{" "}
                      <span style={{ color: global.secondaryColour }}>
                        <strong>{profile.name}</strong>
                      </span>
                    </p>
                    <p>
                      Abha Address:{" "}
                      <span style={{ color: global.secondaryColour }}>
                        <strong>{profile.preferredAbhaAddress}</strong>
                      </span>
                    </p>
                    <p>
                      Abha Number:{" "}
                      <span style={{ color: global.secondaryColour }}>
                        <strong>{profile.ABHANumber}</strong>
                      </span>
                    </p>
                    {profile.hasOwnProperty("dob") && profile.dob !== null ? (
                      <p>
                        Date of Birth:{" "}
                        <span style={{ color: global.secondaryColour }}>
                          <strong>{profile.dob}</strong>
                        </span>
                      </p>
                    ) : (
                      ""
                    )}
                    {profile.hasOwnProperty("gender") &&
                    profile.gender !== null ? (
                      <p>
                        Gender:{" "}
                        <span style={{ color: global.secondaryColour }}>
                          <strong>
                            {profile.gender === "M"
                              ? "Male"
                              : profile.gender === "F"
                              ? "Female"
                              : "NA"}
                          </strong>
                        </span>
                      </p>
                    ) : (
                      ""
                    )}

                    {profile.hasOwnProperty("kycVerified") &&
                    profile.kycVerified !== null ? (
                      <p>
                        KYC Verified:{" "}
                        <span style={{ color: global.secondaryColour }}>
                          {profile.kycVerified.toString() === "True" ||
                          profile.kycVerified.toString() === "true" ? (
                            <VerifiedUserTwoToneIcon
                              style={{
                                color: "#77E4C8",
                                marginBottom: "1%",
                              }}
                            />
                          ) : (
                            <CancelTwoToneIcon
                              style={{
                                color: "#f53169d9",
                                marginBottom: "1%",
                              }}
                            />
                          )}
                        </span>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <KeyboardArrowRightIcon
                    style={{
                      position: "relative",
                      top: "0px",
                      left: "0px",
                      color: global.secondaryColour,
                    }}
                  />
                </Button>
                <Button
                  variant="default"
                  style={{
                    backgroundColor: global.secondaryColour,
                    color: "#fff",
                    height: "25px",
                  }}
                  onClick={() => getProfile(profile.ABHANumber, "AbhaCard")}
                >
                  View ABHA Profile
                </Button>
              </div>
              <hr></hr>
            </Grid>
          ))}
        </Grid>
      </form>
    );
  };

  const populateScreenFlowFour = () => {
    //debugger;
    const profileImage = "data:image/png;base64, " + kycPhotoRes;
    return (
      <Table size="big">
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Number</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{healthIdNoRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Address</strong>
            </TableCell>
            {phrAddress !== null && phrAddress.length > 1 ? (
              <TableCell style={{ textAlign: "left" }}>
                <Select
                  id="state-preferredaddress"
                  value={preferredAbhaAddress}
                  onChange={(event) =>
                    setPreferredAbhaAddress(event.target.value)
                  }
                  style={{ width: "300px", textAlign: "center" }}
                >
                  <MenuItem value="" disabled>
                    Select the Preferred ABHA Address
                  </MenuItem>
                  {phrAddress.map((address) => (
                    <MenuItem key={address} value={address}>
                      {address}
                    </MenuItem>
                  ))}
                </Select>
              </TableCell>
            ) : (
              <TableCell style={{ textAlign: "left" }}>
                {preferredAbhaAddress}
              </TableCell>
            )}
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Name</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{patientName}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Gender</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {genderRes == "M" ? "Male" : "Female"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Mobile</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{mobileRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Date of Birth</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{dobRes}</TableCell>
          </TableRow>
          {stateName !== null &&
          districtName !== null &&
          stateName.trim() != "" &&
          districtName.trim() != "" ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>State</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {stateName} <span>&nbsp;&nbsp;</span>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>District</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {districtName}
              </TableCell>
            </TableRow>
          ) : (
            ""
          )}
          {pinCodeRes !== null &&
          addressRes !== null &&
          addressRes.trim() !== "" &&
          pinCodeRes.trim() !== "" ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Address</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {addressRes} <span>&nbsp;&nbsp;</span>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Pincode</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>{pinCodeRes}</TableCell>
            </TableRow>
          ) : (
            ""
          )}

          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <img src={profileImage} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                }}
                onClick={() => getHealthCard()}
              >
                View ABHA Card
              </Button>
              <Button
                variant="contained"
                className="mx-2 "
                color="default"
                style={{ color: "#f53169d9" }}
                onClick={() => backToHome()}
              >
                Save and Continue
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  const populateScreenFlowFive = () => {
    const profileImageI = "data:image/png;base64, " + profileImageRes;
    return (
      <div className="imgcontainer">
        <div className="text-center">
          <img src={profileImageI} width={"80%"} />
        </div>

        <div style={{ textAlign: "center" }} className="button_container my-2">
          <Button
            variant="contained"
            className="mx-2"
            style={{
              backgroundColor: global.secondaryColour,
              color: "#fff",
            }}
            onClick={() => downloadPng()}
          >
            Download ABHA Card
          </Button>
          <Button
            variant="contained"
            className="mx-2 "
            color="default"
            style={{ color: "#f53169d9" }}
            onClick={() => backToHome()}
          >
            Save and Continue
          </Button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} style={{ padding: "10px" }}>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {showLoader ? (
              <div style={{ textAlign: "center", marginTop: 60 }}>
                <CircularProgress style={{ color: global.secondaryColour }} />
                <h5 style={{ marginTop: 5 }}>Loading...</h5>
              </div>
            ) : (
              generateScreen()
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                pt: 2,
                marginRight: 20,
              }}
            >
              <Button
                style={
                  activeStep === 0 || activeStep === 4
                    ? { color: "#ccc" }
                    : { color: "#f53169d9" }
                }
                onClick={() => handleBack()}
                sx={{ mr: 1 }}
                disabled={activeStep === 0 || activeStep === 4 ? true : false}
              >
                {" "}
                Back
              </Button>
            </Box>
          </React.Fragment>
        )}
      </Paper>
      <Modal
        open={modalState}
        onClose={() => {
          handleModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalState}>
          {modalFor === "2ndStage" ? (
            <Box
              className={classes.modalStyle}
              style={{
                background: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                padding: "15px",
                maxWidth: "80%", // Set maximum width
                margin: "auto", // Center the modal horizontally
              }}
            >
              <h5 id="transition-modal-title">Information</h5>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                <pre>
                  <p>Choose the method with which you want to proceed.</p>
                </pre>
              </Typography>
              <div style={{ display: "flex" }}>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: global.secondaryColour,
                    color: "#fff",
                    width: "200px ",
                  }}
                  component={Link}
                  to="/newabhav3"
                  className={classes.button}
                >
                  Aadhaar
                </Button>
                <Button
                  variant="contained"
                  color="default"
                  component={Link}
                  to="/demoAuthGenerateAbha"
                  className={classes.button}
                  style={{ width: "200px " }}
                >
                  Demographics
                </Button>
              </div>
            </Box>
          ) : (
            <Box
              className={classes.modalStyle}
              style={{
                background: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                padding: "15px",
                maxWidth: "80%", // Set maximum width
                margin: "auto", // Center the modal horizontally
              }}
            >
              <h5 id="transition-modal-title">Information</h5>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ fontSize: "1.7vw", wordWrap: "break-word" }}
              >
                <div id="modalTextBox">{modalData}</div>
              </Typography>
              <Button
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                  paddingBottom: 10,
                  marginTop: 7,
                  width: "200px",
                }}
                onClick={() => handleModalClose()}
              >
                OK
              </Button>
              {isAbhaGenerated != true ? (
                <span
                  style={{
                    color: "#f53169d9",
                    fontWeight: "bold",
                  }}
                >
                  or
                </span>
              ) : (
                ""
              )}
              {isAbhaGenerated != true &&
                (global.isGovtEntity === 1 ? (
                  <Button
                    variant="contained"
                    color="default"
                    style={{ paddingBottom: 10, marginTop: 7, width: "200px" }}
                    onClick={() => handleModalOpen("2ndStage")}
                  >
                    Create ABHA
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="default"
                    style={{ paddingBottom: 10, marginTop: 7, width: "200px" }}
                    component={Link}
                    to="/newabhav3"
                    className={classes.button}
                  >
                    Create ABHA
                  </Button>
                ))}
            </Box>
          )}
        </Fade>
      </Modal>
    </React.Fragment>
  );
}

export default VerifyAbhaV3_old;
